import {Service} from '@/common/Service.js'
import qs from 'qs'

let api_base ={
  poster:function(){
    return Service({
      url:'/hzAdvt/app/list'
    })
  },
  region:function(parentid){
    return Service({
      url:'/base/region/'+parentid
    })
  },
  playsafe_server:function(vid,userid){
    return Service({
      baseURL:'http://v.huazhi.cn/playsafe_server.php',
      params:{
        vid:vid,
        userid:userid
      }
    })
  },
  position_searchparams:function(zyear){
    return Service({
      url:'/possssh/list/search/title',
  	  data:{
		  zyear:zyear
	  }
    })
  },
  position_search:function(positionparams){
    return Service({
      url:'/possssh/list/organs',
	  data:qs.parse(positionparams)
    })
  },
  position_detail:function(position_id){
    return Service({
      url:'/possssh/detail',
	  data:{
		  id:position_id
	  }
    })
  },
  live_replaylist:function(roomid){
    return Service({
      baseURL:'http://v.huazhi.cn/live_replaylist.php',
      params:{
        roomid:roomid,
      }
    })
  },
  get_jssdk:function(url){
    return Service({
      url:'/wx/wxmp_service/getWxJsapiSignature',
      params:{
        url:url,
      }
    })
  },
}

let api_goods ={
  goods_detail:function(courseId){
    return Service({
      url:'/hzCourse/course_service/getCourseDetail',
	  data:{
		  courseId:courseId
	  }
    })
  },
  category:function(){
    return Service({
      url:'/hzCourse/course_service/getCondition'
    })
  },
  goods_list:function(paramsdata){
	return Service({
	  url:'/hzCourse/course_service/getCourseList',
	  data:paramsdata
	})
  },
  recommend_list:function(paramsdata){
  	return Service({
  	  url:'/hzCourse/course_service/getRecommendCourseList',
  	  data:paramsdata
  	})
  },
  goods_search:function(pagesize,pagenum,keywords){
  	return Service({
  	  url:'/goods/goods_search/'+pagesize+'/'+pagenum+'/'+keywords
  	})
  },
  goods_comment:function(pageSize,pageNo,courseId){
  	return Service({
  	  url:'/comment/hzcourse_service/list',
	  data:{
		  courseId:courseId,
		  pageNo:pageNo,
		  pageSize:pageSize
	  }
  	})
  },
  goods_shiting:function(goods_id){
  	return Service({
  	  url:'/goods/goods_shiting/'+goods_id
  	})
  }
}


let api_user ={
  my_video_detail:function(goodsid,usertoken){
    return Service({
      url:'/user/my_video_detail/'+goodsid+'/'+usertoken
    })
  },
  my_live_detail:function(goodsid,usertoken){
	return Service({
	url:'/user/my_live_detail/'+goodsid+'/'+usertoken
	})
  },
  my_live:function(pagesize,pagenum,usertoken){
  	return Service({
  	url:'/user/my_live/'+pagesize+'/'+pagenum+'/'+usertoken
  	})
  },
  my_video:function(pagesize,pagenum,usertoken){
  	return Service({
  	url:'/user/my_video/'+pagesize+'/'+pagenum+'/'+usertoken
  	})
  },
  wxregister:function(openid,mobile,checkcode,qd){
  	return Service({
  	url:'/hzuser/user_service/bindOpenid',
	data:{
		openid:openid,
		mobile:mobile,
		checkcode:checkcode,
		qd:qd
	}
  	})
  },
  smssend:function(telephone){
  	return Service({
  	url:'/hzuser/user_service/sendSms',
	data:{
		mobile:telephone,
		_up_:"0|0|0|0|0|0"
	}
  	})
  },
  wxunlock:function(){
  	return Service({
  	url:'/hzuser/user_service/unbindOpenid'
  	})
  },
  userinfo:function(usertoken){
  	return Service({
  	url:'/user/userinfo/'+usertoken
  	})
  },
  order_list:function(){
  	return Service({
  	url:'/hzOrder/order_service/myOrderList'
  	})
  },
  wxpay:function(orderId){
  	return Service({
	url:'/hzPay/weixin_service/getJSAPIOrderSign',
	data:{
		orderId:orderId
	}
  	})
  },
  getdocfile_list:function(courseId){
  	return Service({
  	url:'/hzCourse/course_service/getCourseMaterialList',
	data:{
		courseId:courseId
	}
  	})
  },
  coupon_list:function(pagesize,pagenum,usertoken){
  	return Service({
  	url:'/user/coupon_list/'+pagesize+'/'+pagenum+'/'+usertoken
  	})
  },
  coupon_list_condition:function(productId){
  	return Service({
  	url:'/coupon/coupon_service/getOrderCouponList',
	data:{
		productId:productId
	}
  	})
  },
  wxlogin:function(wxopenid){
  	return Service({
  	url:'/user/wxlogin/'+wxopenid
  	})
  },
  my_course_detail:function(goodsid,usertoken){
	  return Service({
	  url:'/user/my_course_detail/'+goodsid+'/'+usertoken
	  })
  },
  wxorder:function(paramsdata){
	  console.log(paramsdata);
	  return Service({
	  url:'/hzOrder/order_service/submitOrder',
	  data:qs.parse(paramsdata)
	  })
  },
  pay_zero:function(orderid){
	  return Service({
	  url:'/user/pay_zero/'+orderid
	  })
  },
  pay:function(orderid,orderamount){
  	  return Service({
  	  url:'/user/pay/'+orderid+'/'+orderamount
  	  })
  },
  usersignin:function(){
    return Service({
      url:'/user/login_register_service/insertUserSign'
    })
  },
  usersignin_list:function(){
    return Service({
      url:'/user/login_register_service/selectMonthSign'
    })
  },
  // 获取课程表
  getCourseResourceTree:function(courseId){
   return Service({
  	   url:'/hzCourse/course_service/getCourseResourceTree',
  	   data:{
  		   courseId:courseId
  	   }
   })
  },
  getMyCourseList:function(){
   return Service({
  	   url:'/hzCourse/course_service/getMyCourseList'
   })
  },
  getPlayData:function(courseId,lessonId){
   return Service({
  	   url:'/hzCourse/course_service/getPlayData',
	   data:{
		   courseId:courseId,
		   lessonId:lessonId
	   }
   })
  },
  updateLessonStudyRate:function(courseId,lessonId,currentTimes){
   return Service({
  	   url:'/hzCourse/course_service/updateLessonStudyRate',
  	   data:{
  		   courseId:courseId,
  		   lessonId:lessonId,
  		   currentTimes,currentTimes
  	   }
   })
  },
  downloadMaterial:function(courseId,lessonId,materialId){
   return Service({
  	   url:'/hzCourse/course_service/downloadMaterial',
  	   data:{
  		   courseId:courseId,
  		   lessonId:lessonId,
		   materialId:materialId
  	   }
   })
  },
  getPayStatus:function(orderId){
   return Service({
  	   url:'/hzOrder/order_service/getPayStatus',
  	   data:{
  		   orderId:orderId
  	   }
   })
  },
  loginByWeixinCode:function(code){
   return Service({
  	   url:'/hzuser/user_service/loginByWeixinCode',
  	   data:{
  		   code:code
  	   }
   })
  },
  // 获取用户在班级里的真实姓名
  getUserInfoAtClass:function(){
  	return Service({
  		url: '/user/login_register_service/getUserInfoAtClass',
  	})
  },
  getAfterBuyShowImgUrl:function(courseId){
   return Service({
  	   url:'/hzCourse/course_service/getAfterBuyShowImgUrl',
  	   data:{
  		   courseId:courseId
  	   }
   })
  },
  
}


let api_polyv ={
  getPlayListById:function(vlistid){
    return Service({
      baseURL:'http://v.polyv.net/uc/services/rest',
      //url:'http://v.polyv.net/uc/services/rest',
      params:{
        method:"getPlayListById",
        readtoken:"4UcQgz0vIB-6byTx0Nl1R-oJeXw3XPCz",
        id:vlistid
      }

    })
  },
  region:function(parentid){
    return Service({
      url:'/base/region/'+parentid
    })
  }
}


let api_group ={
	group_statusscan:function(){
		return Service({
		  url:'/group/group_statusscan/'
		})
	},
	usergroup_list:function(pagesize,pageno,shopgroup_id){
		return Service({
		  url:'/group/usergroup_list/'+pagesize+'/'+pageno+'/'+shopgroup_id
		})
	},
	get_usershopgroup_status:function(shopgroup_id,usertoken){
		return Service({
		  url:'/group/get_usershopgroup_status/'+shopgroup_id+'/'+usertoken
		})
	},
	usergroup_creategroup:function(shopgroup_id,usertoken){
		return Service({
		  url:'/group/usergroup_creategroup/'+shopgroup_id+'/'+usertoken
		})
	},
	shopgroup_detail:function(shopgroup_id){
		return Service({
		  url:'/group/shopgroup_detail/'+shopgroup_id
		})
	},
	usergroup_joingroup:function(usergroupid,usertoken){
		return Service({
		  url:'/group/usergroup_joingroup/'+usergroupid+'/'+usertoken
		})
	},
	shopgroup_list:function(pagesize,pagenum,projectid){
		return Service({
		  url:'/group/shopgroup_list/'+pagesize+'/'+pagenum+'/'+projectid
		})
	},
	shopgroup_search:function(pagesize,pagenum,keyword){
		return Service({
		  url:'/group/shopgroup_search/'+pagesize+'/'+pagenum+'/'+keyword
		})
	},
	myusergroup_list:function(pagesize,pagenum,token,statetype){
		return Service({
		  url:'/group/myusergroup_list/'+pagesize+'/'+pagenum+'/'+token+'/'+statetype
		})
	},
	group_pay:function(orderid,orderamount){
		return Service({
		  url:'/group/group_pay/'+orderid+'/'+orderamount
		})
	},
}

// 职位库
let api_position = {
  queryList:function(paramsdata) {
    return Service({
      url: '/possssh/getCondition',
      data:paramsdata
    })
  },
  possshList:function(paramsdata) {
    return Service({
      url: '/possssh/list',
      data:paramsdata
    })
  },
  positionDetails:function(paramsdata) {
    return Service({
      url: '/possssh/getDetailByCode',
      data:paramsdata
    })
  },
  gainInfo:function(paramsdata) {
    return Service({
      url: '/hzuser/user_service/createSubscribe',
      data:paramsdata
    })
  },
  rankList:function(paramsdata) {
    return Service({
      url: '/possssh/interviewerList',
      data:paramsdata
    })
  }
}

export  {api_base,api_goods,api_user,api_polyv,api_group,api_position}
